import type { PoseFrame } from '@tbc/core';
import { POSE_EDGES } from '@tbc/core/pose';

/**
 * Draw a stickman skeleton on a Canvas2D context whose dimensions match the
 * displayed video. Landmarks are normalized to [0, 1].
 */
export function drawStickman(ctx: CanvasRenderingContext2D, frame: PoseFrame): void {
  const w = ctx.canvas.width;
  const h = ctx.canvas.height;

  ctx.save();
  ctx.lineWidth = 3;
  ctx.strokeStyle = 'rgba(250, 204, 21, 0.95)'; // racket-yellow
  ctx.fillStyle = 'rgba(22, 163, 74, 0.95)'; // court-green

  for (const [aIdx, bIdx] of POSE_EDGES) {
    const a = frame[aIdx];
    const b = frame[bIdx];
    if (!a || !b) continue;
    if (a.visibility < 0.3 || b.visibility < 0.3) continue;
    ctx.beginPath();
    ctx.moveTo(a.x * w, a.y * h);
    ctx.lineTo(b.x * w, b.y * h);
    ctx.stroke();
  }

  for (const lm of frame) {
    if (lm.visibility < 0.3) continue;
    ctx.beginPath();
    ctx.arc(lm.x * w, lm.y * h, 4, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.restore();
}

export function clearCanvas(ctx: CanvasRenderingContext2D): void {
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
}
